import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useMemo, useState } from "react";
import useProcessData from "../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import { Confirm } from "../../Components/Confirmation/Confirm";
import { closeVehicle } from "../../../Utils/AllPagesQuriesAndMutations";
import { useSelector } from "react-redux";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import { useDispatch } from "react-redux";

const queryfunction = (fields) => {
  const query = gql`
    query getAllVehiclesForERP {
      getAllVehiclesForERP {
       _id
       ${fields?.join(" ")}
      }
    }
  `;

  return query;
};

const MyVehicleManagement = () => {
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [Id, setId] = useState("");
  const [toggle, setToggle] = useState(false);
  const Key = "My_Vehicle_Management";
  const query = queryfunction([]);
  const ReduxData = useSelector((store) => store?.UniqueTableReducer);
  const fielddata = ReduxData?.My_Vehicle_Management?.Selected_Row;
  const dispatch = useDispatch();

  const config = useMemo(
    () => ({
      dataKey: "getAllVehiclesForERP",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
    }),
    []
  );

  const [fetchvehicledetails, { loading: queryLoading, error, data }] = useLazyQuery(query, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "cache-and-network",
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const [closeVehicleManagement, { loading: EditTruckLoading }] = useMutation(closeVehicle, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const closeFunction = () => {
    setToggle(true);
    setId(fielddata._id);
  };

  function Submit(Id) {
    closeVehicleManagement({
      variables: {
        id: fielddata._id,
        isActive: false,
      },
    })
      .then((res) => {
        dispatch({ type: "Refetch", payload: true });
        SuccessToast("Vehicle Closed Successfully");
        setToggle(false);
      })
      .catch((err) => ErrorToast("Error while closing vehicle"));
  }

  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchvehicledetails, setIsLoading, Key);

  useProcessData(data, setFormData, config, error);

  return (
    <>
      <div>
        <HeaderDiv title={"My Vehicle Management"} TableKey={Key} closeFun={closeFunction} MoreActions={{Is_Close:true}} />
        {isLoading ? (
          <Loading />
        ) : !formData?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <>
            {(queryLoading || loading) && <div className="loader-line-div" />}
            <LoadTable
              title={Key}
              data={formData}
              loading={isLoading}
              error={error}
              multiSelect={false}
              TableHeaders={TableHeaders}
            />
          </>
        )}
      </div>
      {toggle && (
        <Confirm
          settoggle={setToggle}
          loadingState={EditTruckLoading}
          toggle={toggle}
          submitType="Yes"
          submit={() => Submit(Id)}
          message={"Are You Sure You want to Close This Truck"}
        />
      )}
    </>
  );
};

export default MyVehicleManagement;
